











































import { Prop, Component, Vue } from "vue-property-decorator";
import EditableTableCell from "../components/coordinate/editable-table-cell.vue";
import { Listenable } from "../util/Listenable";
import { UIModel } from "../UIModel";
import { getModelSets } from "@/api/API";
import _ from 'lodash';
import { FrontendBIM360Modelset } from '@/model/frontend/FrontendBIM360Modelset';
import { BIM360Modelset } from '@/model/BIM360Modelset';
import { FrontendBIM360Project } from '@/model/frontend/FrontendBIM360Project';
@Component({
  components: { EditableTableCell },
})
export default class Coordinate extends Vue {
  @Prop({ required: true }) public model!: UIModel;

  public modelSets: FrontendBIM360Modelset[] = [];
  private isLoading: boolean = false;
  private isEmpty: boolean = false;
  private changesMade: boolean = false;
  private changedRows = [];
  private refreshLoadingCount = 4;

  private onReset = new Listenable<boolean>();
  
  get projectName() {
    if(this.refreshLoadingCount)
    {
      this.refreshLoadingCount -= 1;
      this.getModelSets();
    }
    return this.model?.selectedProject?.name
  }

  async confirm(): Promise<void> {
    this.changesMade = false;
    for(let i in this.modelSets) {
        let originalModelSet = this.model.modelSets[i];
        let newModelSet = this.modelSets[i];
        if((originalModelSet.name != newModelSet.name) || (originalModelSet.description != newModelSet.description)) {
            newModelSet.saveChanges();
        }
        await this.model.getModelSets();
    }
    this.onReset.call(true);
  }

  cancel(): void {
    this.onReset.call(false);
    this.modelSets = _.cloneDeep(this.model.modelSets);
    this.changesMade = false;
  }

  public async getModelSets() {
    if (this.model?.selectedHub && this.model?.selectedProject) {
      await this.model.initCoordinateModule();
      this.modelSets = _.cloneDeep(this.model.modelSets);
    }
  }

  public async chooseProject(project: FrontendBIM360Project): Promise<void> {
    this.model.selectProject(project);
  }
}
